module.exports = __webpack_public_path__ + "media/landing_work/home/images/check-purple-f055271deaf89c8154c72107dcb36c72.svg";